/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import cn from 'classnames'
import { connect } from 'react-redux'

import Navbar from '../../containers/Navbar'
import Button from '../../components/Button'
import OrderListControlBar from '../../containers/tabs/OrderListControlBar'

import { preOrdersRequested } from '../../actions/order'

import styles from './Tabs.module.scss'
import TabOrdersList from '../../containers/tabs/TabOrdersList'
import { getSearchQuery } from '../../selectors/search'
import { setActiveRevenueCenter } from '../../actions/revenueCenter'
import { makeGetCurrentMenu } from '../../selectors/menus'
import { fetchPromotions } from '../../actions/promotion'

const Tabs = ({ history, searchQuery, revenueCenterId, onMount, fetchPreOrders, className }) => {
  const classNames = cn(styles.tabs, className)

  const reloadPreorders = () => {
    return fetchPreOrders(null, null)
  }

  useEffect(() => {
    onMount(revenueCenterId)
  }, [revenueCenterId])

  let style = {}

  if (searchQuery) {
    style.backgroundColor = '#11121d'
  }

  return (
    <div className={classNames}>
      <Navbar className={styles.navbar} />
      <OrderListControlBar className={styles.orderListControlBar} reloadPreorders={reloadPreorders} />
      <div className={styles.content} style={style}>
        <Button className={styles.newOrderButton} onClick={() => history.replace('/tab-order')}>New Order</Button>
        <TabOrdersList className={styles.ordersContainer} />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const searchQuery = getSearchQuery(state)
  const currentMenu = makeGetCurrentMenu()(state)
  const revenueCenterId = currentMenu?.standUuid

  return { searchQuery, revenueCenterId }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchPreOrders: (salesEventId, standUuids) => {
      dispatch(preOrdersRequested(salesEventId, standUuids))
    },
    onMount: (revenueCenterId) => {
      dispatch(setActiveRevenueCenter(revenueCenterId))
      dispatch(fetchPromotions({ revenueCenterId }))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tabs)
